export default (props, vars) =>
  vars?.['useform1']?.['register']('companyName', { required: true });
